import React from 'react';

const PortfolioInput = ({ portfolio, investmentAmount, onInvestmentChange }) => {
  // Calculate average interest rate safely
  const calculateAverageInterestRate = () => {
    try {
      if (!portfolio || !portfolio.projects || portfolio.projects.length === 0) {
        return 0;
      }
      const validProjects = portfolio.projects.filter(p => p && typeof p.interestRate === 'number');
      if (validProjects.length === 0) return 0;
      
      const totalRate = validProjects.reduce((sum, p) => sum + p.interestRate, 0);
      return (totalRate / validProjects.length) * 100;
    } catch (error) {
      console.error('Error calculating average interest rate:', error);
      return 0;
    }
  };

  // Handle investment change safely
  const handleInvestmentChange = (e) => {
    try {
      const value = e.target.value === '' ? 0 : Math.max(0, parseFloat(e.target.value) || 0);
      onInvestmentChange(portfolio?.id || 1, value);
    } catch (error) {
      console.error('Error handling investment change:', error);
      onInvestmentChange(portfolio?.id || 1, 0);
    }
  };

  return (
    <div className="bg-white rounded-md border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200 w-[500px] py-2 px-4">
      <div className="grid grid-cols-[200px,auto] items-center gap-4">
        <div>
          <h3 className="text-sm font-medium text-gray-800">{portfolio?.name || 'Portfolio'}</h3>
        </div>
        <div className="flex items-center gap-4">
          <div className="relative w-36">
            <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
              <span className="text-gray-500 text-xs">$</span>
            </div>
            <input
              type="number"
              min="0"
              step="1000"
              value={investmentAmount || ''}
              onChange={handleInvestmentChange}
              className="w-full pl-4 pr-2 py-1 text-xs border border-gray-200 rounded focus:ring-1 focus:ring-gold focus:border-gold text-gray-700"
              placeholder="Monto"
            />
          </div>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500">Interés Promedio:</span>
            <span className="text-xs font-medium text-gray-700">{calculateAverageInterestRate().toFixed(1)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioInput; 